import IMemberUserRepository from "../../../domain/interfaces/repositories/IMemberUserRepository";

export const ReadMemberUserQuery = (repository: IMemberUserRepository, id: string)=>{
    return repository.getById(id)

}